<template>
  <div>
    <div
      style="
        position: fixed;
        top: 20px;
        z-index: 1;
        backdrop-filter: blur(10px);
      "
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div class="page-heading d-flex align-items-center">
        <img
          src="../../assets/bckarrow.svg"
          class="pointer"
          alt=""
          @click="goBack"
        />
        <div class="main-head ml-4">
          <span>Review Candidate Details</span>
        </div>
      </div>

      <div class="d-flex">
        <div class="rcs-left-container">
          <div class="viewcandidate-profile-list mt-0">
            <div class="d-flex">
              <div class="mr-4" style="width: 7%">
                <div class="profile-img">
                  <img
                    v-if="profileInfo.image == null"
                    class="h-100 dd-100"
                    src="../../assets/defaultprofile.svg"
                    alt="not available"
                    srcset=""
                  />
                  <img
                    v-else
                    class="h-100 w-100"
                    :src="profileInfo.image"
                    alt="not available"
                    srcset=""
                  />
                </div>
              </div>

              <div style="width: 100%" class="mx-2">
                <div class="ml-2 d-flex justify-content-between">
                  <div>
                    <div class="d-flex">
                      <div class="cvs-gridcard-name">
                        {{ profileInfo.firstName }} {{ profileInfo.middleName }}
                        {{ profileInfo.lastName }}
                      </div>
                      <div
                        class="ml-2 mr-2"
                        v-if="profileInfo.designation != null"
                      >
                        <img
                          class="pb-1"
                          src="../../assets/img/cvsearch/Line.svg"
                          alt=""
                        />
                      </div>
                      <div class="cvs-gridcard-name">
                        {{ profileInfo.designation }}
                      </div>
                    </div>
                    <div class="vcs-email mt-2">
                      {{ profileInfo.email }}
                    </div>
                  </div>
                  <div v-if="!LoaderStatus && statusInfo.status != 0">
                    <b-button v-b-modal.remarksModal class="addbtn pl-3 pr-3">
                      <span>View Remarks</span>
                    </b-button>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between align-items-center mt-3"
                >
                  <div style="width: 100%" class="d-flex align-items-center">
                    <div class="d-flex align-items-center" style="width: 40%">
                      <img
                        src="../../assets/img/cvsearch/expblock.svg"
                        alt=""
                      />
                      <template
                        v-if="
                          profileInfo.totalYearsOfExp == '' ||
                          profileInfo.totalYearsOfExp == null ||
                          profileInfo.totalYearsOfExp == undefined
                        "
                      >
                        <div class="ml-1 cv-not-added">Not disclosed</div>
                      </template>
                      <template v-else>
                        <div class="ml-1 skills-text text-truncate">
                          {{ profileInfo.totalYearsOfExp }} years
                        </div>
                      </template>
                    </div>

                    <div
                      class="ml-2 d-flex align-items-center"
                      style="width: 30%"
                    >
                      <img src="../../assets/img/cvsearch/ctc.svg" alt="" />
                      <template
                        v-if="
                          profileInfo.currentCTC == '' ||
                          profileInfo.currentCTC == null ||
                          profileInfo.currentCTC == undefined
                        "
                      >
                        <div class="ml-1 cv-not-added">Not disclosed</div>
                      </template>
                      <template v-else>
                        <div class="ml-1 skills-text text-truncate">
                          {{ profileInfo.currentCTC }} LPA
                        </div>
                      </template>
                    </div>

                    <div
                      class="ml-2 d-flex align-items-center"
                      style="width: 30%"
                    >
                      <img
                        src="../../assets/img/cvsearch/locblock.svg"
                        alt=""
                      />
                      <template
                        v-if="
                          profileInfo.city == '' ||
                          profileInfo.city == null ||
                          profileInfo.city == undefined
                        "
                      >
                        <div class="ml-1 cv-not-added">Not disclosed</div>
                      </template>
                      <template v-else>
                        <div class="ml-1 skills-text text-truncate">
                          {{ profileInfo.city }}
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="viewcandidate-profile-list">
            <div class="d-flex align-items-center">
              <div class="ml-2 d-flex align-items-center" style="width: 30%">
                <img src="../../assets/img/cvsearch/ctc.svg" alt="" />
                <div class="cvs-subheads-gcard ml-2">Current CTC</div>
                <template
                  v-if="
                    profileInfo.currentCTC == '' ||
                    profileInfo.currentCTC == null ||
                    profileInfo.currentCTC == undefined
                  "
                >
                  <div class="ml-1 cv-not-added">Not disclosed</div>
                </template>
                <template v-else>
                  <div class="ml-3 skills-text text-truncate">
                    {{ profileInfo.currentCTC }} LPA
                  </div>
                </template>
              </div>

              <div class="ml-2 d-flex align-items-center" style="width: 30%">
                <img src="../../assets/img/cvsearch/ctc.svg" alt="" />
                <div class="cvs-subheads-gcard ml-2">Expected CTC</div>
                <template
                  v-if="
                    profileInfo.currentCTC == '' ||
                    profileInfo.currentCTC == null ||
                    profileInfo.currentCTC == undefined
                  "
                >
                  <div class="ml-1 cv-not-added">Not disclosed</div>
                </template>
                <template v-else>
                  <div class="ml-3 skills-text text-truncate">
                    {{ profileInfo.expectedCTC }} LPA
                  </div>
                </template>
              </div>
              <div class="ml-2 d-flex align-items-center" style="width: 40%">
                <img src="../../assets/img/cvsearch/locblock.svg" alt="" />
                <div class="cvs-subheads-gcard ml-2">Pref. Location</div>

                <div
                  class="ml-3 skills-text text-truncate"
                  v-if="profileInfo.willingToRelocate != null"
                >
                  {{ profileInfo.willingToRelocateTo.join(",") }}
                </div>
                <div class="ml-3 cv-not-added" v-else>Not disclosed</div>
              </div>
            </div>
          </div>

          <!-- education -->
          <div
            class="viewcandidate-educationinfo mt-3 pointer"
            @click="showEducation = !showEducation"
          >
            <div class="d-flex justify-content-between">
              <div class="cand-container-main-heading">Education</div>
              <div class="d-flex">
                <div>
                  <img
                    v-if="showEducation == false"
                    src="../../assets/img/cvsearch/downarrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/cvsearch/uparrow.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <!-- getting education data if we click on dropdown -->
            <div
              class="mt-3"
              v-if="showEducation == true"
              :class="
                profileInfo.educationalInfo == undefined ||
                profileInfo.educationalInfo.length == 0
                  ? 'd-flex justify-content-center align-items-center'
                  : ''
              "
            >
              <div
                v-if="
                  profileInfo.educationalInfo == undefined ||
                  profileInfo.educationalInfo.length == 0
                "
              >
                <div class="mb-2">
                  <img src="../../assets/img/cvsearch/cvnodata.svg" alt="" />
                </div>
                <div class="ml-5 cv-not-added">Not disclosed</div>
              </div>

              <template v-else>
                <div
                  v-for="(eduInfo, index) in profileInfo.educationalInfo"
                  :key="index"
                >
                  <div class="d-flex mt-3">
                    <div style="width: 6%">
                      <img
                        src="../../assets/img/cvsearch/cardlocation.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 94%">
                      <div class="d-flex justify-content-between mt-2">
                        <div style="width: 65%">
                          <div
                            class="cand-container-subheading text-truncate ml-2"
                          >
                            {{ eduInfo.institute }}
                          </div>
                          <div
                            class="d-flex cand-dash-asses-desc text-break mt-2"
                          >
                            <div>{{ eduInfo.qualification }}</div>
                            <div class="ml-2 mr-2">
                              <img
                                src="../../assets/img/cvsearch/greydot.svg"
                                alt=""
                              />
                            </div>
                            <div>{{ eduInfo.location }}</div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-end"
                          style="width: 35%"
                        >
                          <div class="datesofcontent">
                            {{ getITCDateMonth(eduInfo.yearOfPassout) }}
                            {{
                              getITCDateYear(eduInfo.yearOfPassout) -
                              eduInfo.courseDuration
                            }}
                            - {{ getITCDateMonth(eduInfo.yearOfPassout) }}
                            {{ getITCDateYear(eduInfo.yearOfPassout) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- do use this condition hence last line vl be hidden -->
                  <hr
                    class="mt-3 mb-3"
                    v-if="profileInfo.educationalInfo.length - 1 != index"
                  />
                </div>
              </template>
            </div>
          </div>

          <!-- experience  -->
          <div
            class="viewcandidate-educationinfo mt-3 pointer"
            @click="showExperience = !showExperience"
          >
            <div class="d-flex justify-content-between">
              <div class="cand-container-main-heading">Experience</div>
              <div class="d-flex gap-4">
                <div>
                  <img
                    v-if="showExperience == false"
                    src="../../assets/img/cvsearch/downarrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/cvsearch/uparrow.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <!-- getting experience data if we click on dropdown -->
            <div
              class="mt-3"
              v-if="showExperience == true"
              :class="
                profileInfo.experience == undefined ||
                profileInfo.experience.length == 0
                  ? 'd-flex justify-content-center align-items-center'
                  : ''
              "
            >
              <div
                v-if="
                  profileInfo.experience == undefined ||
                  profileInfo.experience.length == 0
                "
              >
                <div class="mb-2">
                  <img src="../../assets/img/cvsearch/cvnodata.svg" alt="" />
                </div>
                <div class="ml-5 cv-not-added">Not disclosed</div>
              </div>
              <template v-else>
                <div
                  v-for="(expinfo, index) in profileInfo.experience"
                  :key="index"
                >
                  <div class="d-flex mt-3">
                    <div style="width: 6%">
                      <img src="../../assets/img/cvsearch/cardexp.svg" alt="" />
                    </div>
                    <div style="width: 94%">
                      <div class="d-flex justify-content-between mt-2 ml-2">
                        <div style="width: 65%">
                          <div class="cand-container-subheading text-truncate">
                            {{ expinfo.companyName }}
                          </div>
                          <div
                            class="d-flex cand-dash-asses-desc text-break mt-2"
                          >
                            <div>{{ expinfo.designation }}</div>
                            <div class="ml-2 mr-2">
                              <img
                                src="../../assets/img/cvsearch/greydot.svg"
                                alt=""
                              />
                            </div>
                            <div>{{ expinfo.location }}</div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-end"
                          style="width: 35%"
                        >
                          <div class="datesofcontent">
                            {{ getITCDateTime(expinfo.startDate) }} -
                          </div>
                          <div class="datesofcontent">
                            &nbsp;
                            <span v-if="expinfo.currentExperience == true">
                              present
                            </span>
                            <span v-else>
                              {{ getITCDateTime(expinfo.endDate) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- do use this condition hence last line vl be hidden -->
                  <hr
                    class="mt-3 mb-3"
                    v-if="profileInfo.experience.length - 1 != index"
                  />
                </div>
              </template>
            </div>
          </div>

          <!-- skills  -->
          <div
            class="viewcandidate-educationinfo mt-3 pointer"
            @click="showSkills = !showSkills"
          >
            <div class="d-flex justify-content-between">
              <div class="cand-container-main-heading">Skills</div>
              <div class="d-flex gap-4">
                <div>
                  <img
                    v-if="showSkills == false"
                    src="../../assets/img/cvsearch/downarrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/cvsearch/uparrow.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <!-- getting skiils data if we click on dropdown -->
            <div
              class="mt-3"
              v-if="showSkills == true"
              :class="
                profileInfo.skills == undefined ||
                profileInfo.skills.length == 0
                  ? 'd-flex justify-content-center align-items-center'
                  : ''
              "
            >
              <div
                v-if="
                  profileInfo.skills == undefined ||
                  profileInfo.skills.length == 0
                "
              >
                <div class="mb-2">
                  <img src="../../assets/img/cvsearch/cvnodata.svg" alt="" />
                </div>
                <div class="ml-5 cv-not-added">Not disclosed</div>
              </div>
              <template v-else>
                <div
                  v-for="(skillinfo, index) in profileInfo.skills"
                  :key="index"
                >
                  <div class="d-flex mt-3">
                    <div style="width: 6%">
                      <img
                        src="../../assets/img/cvsearch/cardskill.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 94%">
                      <div class="d-flex justify-content-between mt-2 ml-2">
                        <div style="width: 85%">
                          <div class="cand-container-subheading text-break">
                            {{ skillinfo.skillName }}
                          </div>
                          <div
                            class="
                              d-flex
                              cand-dash-asses-desc
                              text-truncate
                              mt-2
                            "
                          >
                            <div>{{ skillinfo.expertiseLevel }}</div>
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-end"
                          style="width: 15%"
                        >
                          <div>
                            <span
                              v-if="
                                skillinfo.yearsOfExp == '' ||
                                skillinfo.yearsOfExp == null
                              "
                              class="cv-not-added"
                            >
                              Not Disclosed
                            </span>
                            <span
                              class="datesofcontent"
                              v-else-if="skillinfo.yearsOfExp == '1'"
                            >
                              {{ skillinfo.yearsOfExp }} Year
                            </span>
                            <span class="datesofcontent" v-else>
                              {{ skillinfo.yearsOfExp }} Years
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- do use this condition hence last line vl be hidden -->
                  <hr
                    class="mt-3 mb-3"
                    v-if="profileInfo.skills.length - 1 != index"
                  />
                </div>
              </template>
            </div>
          </div>

          <!-- Projects  -->
          <div
            class="viewcandidate-educationinfo mt-3 pointer"
            @click="showProjects = !showProjects"
          >
            <div class="d-flex justify-content-between">
              <div class="cand-container-main-heading">Projects</div>
              <div class="d-flex gap-4">
                <div>
                  <img
                    v-if="showProjects == false"
                    src="../../assets/img/cvsearch/downarrow.svg"
                    alt=""
                  />
                  <img
                    v-else
                    src="../../assets/img/cvsearch/uparrow.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>

            <!-- getting projects data if we click on dropdown -->
            <div
              class="mt-3"
              v-if="showProjects == true"
              :class="
                profileInfo.projects == undefined ||
                profileInfo.projects.length == 0
                  ? 'd-flex justify-content-center align-items-center'
                  : ''
              "
            >
              <div
                v-if="
                  profileInfo.projects == undefined ||
                  profileInfo.projects.length == 0
                "
              >
                <div class="mb-2">
                  <img src="../../assets/img/cvsearch/cvnodata.svg" alt="" />
                </div>
                <div class="ml-5 cv-not-added">Not disclosed</div>
              </div>
              <template v-else>
                <div
                  v-for="(projinfo, index) in profileInfo.projects"
                  :key="index"
                >
                  <div class="d-flex mt-3">
                    <div style="width: 6%">
                      <img
                        src="../../assets/img/cvsearch/cardskill.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 94%">
                      <div class="d-flex justify-content-between">
                        <div style="width: 75%">
                          <!-- note do no remove project name -->
                          <div class="projname-box text-break">
                            <span class="ml-2"
                              >Project Name - {{ projinfo.title }}</span
                            >
                          </div>
                        </div>
                        <div
                          class="d-flex justify-content-end ml-2"
                          style="width: 25%"
                        >
                          <div class="datesofcontent">
                            {{ getITCDateTime(projinfo.startDate) }} -
                          </div>
                          <div class="datesofcontent">
                            &nbsp;
                            <span v-if="projinfo.currentProject == true">
                              present
                            </span>
                            <span v-else>
                              {{ getITCDateTime(projinfo.endDate) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex mt-3">
                    <div style="width: 5%"></div>
                    <div style="width: 95%" class="d-flex align-items-center">
                      <div style="width: 30%">
                        <div class="proj-submainheads">Project Role</div>
                        <div
                          class="d-flex cand-dash-asses-desc mt-2 text-break"
                        >
                          {{ projinfo.role }}
                        </div>
                      </div>
                      <div style="width: 30%" class="ml-2">
                        <div class="proj-submainheads">Domain</div>
                        <div
                          class="d-flex cand-dash-asses-desc mt-2 text-break"
                        >
                          {{ projinfo.domain }}
                        </div>
                      </div>
                      <div style="width: 40%" class="ml-2">
                        <div class="proj-submainheads">Responsibility</div>
                        <div
                          class="d-flex cand-dash-asses-desc mt-2 text-break"
                        >
                          {{ projinfo.responsibility }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex mt-3">
                    <div style="width: 5%"></div>
                    <div style="width: 95%">
                      <div class="proj-submainheads">Skills Used</div>
                      <div
                        class="d-flex flex-wrap align-items-center mt-2"
                        style="width: 100%"
                      >
                        <div
                          class="vcs-skillBox"
                          v-for="(projskill, index) in projinfo.skillsUsed"
                          :key="index"
                        >
                          {{ projskill }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mt-3">
                    <div style="width: 5%"></div>
                    <div style="width: 95%">
                      <div class="proj-submainheads">Description</div>
                      <div class="cand-dash-asses-desc text-break mt-2">
                        {{ projinfo.description }}
                      </div>
                    </div>
                  </div>
                  <!-- do use this condition hence last line vl be hidden -->
                  <hr
                    class="mt-3 mb-3"
                    v-if="profileInfo.projects.length - 1 != index"
                  />
                </div>
              </template>
            </div>
          </div>

          <!-- button -->
          <div
            v-if="
              statusInfo.status == 0 &&
              roles.includes('ACCEPT_REJECT_APPLICATION')
            "
            class="d-flex mt-4 vcs-left-cont-btn"
          >
            <b-button
              v-b-modal.acceptmodal
              class="addbtn pl-3 pr-3 mr-3"
              @click="selectionKey = true"
            >
              <span class="ml-2">Accept Application</span>
            </b-button>
            <div
              class="
                cancelbtntext
                d-flex
                align-items-center
                justify-content-center
                pointer
              "
              v-b-modal.rejectmodal
              @click="selectionKey = false"
            >
              <span>Reject Application</span>
            </div>
          </div>
        </div>
        <div class="ap-right-container ml-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="rcs-remarks-right">Resume</div>
            <div class="cj-viewjd-det-txt" v-if="profileInfo.resume != null">
              <img
                @click="downloadFeedback(profileInfo.resume)"
                src="../../assets/img/cvsearch/download.svg"
                alt=""
              />
              <span class="view-all-test ml-2"> <u>Download Resume</u></span>
            </div>
          </div>
          <div class="mt-4 rcs-template-card" v-if="profileInfo.resume != null">
            <div>
              <pdf
                ref="pdf"
                style="border: 1px solid black"
                :src="profileInfo.resume"
                :page="currentPage"
                @num-pages="numPages = $event"
                @link-clicked="currentPage = $event"
                @page-loaded="currentPage = $event"
              ></pdf>
            </div>
            <div class="mt-3">
              <b-pagination
                class="d-flex align-items-center"
                v-model="currentPage"
                pills
                :total-rows="numPages"
                :per-page="perPage"
                align="center"
                first-number
                last-number
              >
                <template #prev-text>
                  <span>
                    <img src="../../assets/pageleft.svg" alt="" />
                  </span>
                </template>
                <template #next-text>
                  <span>
                    <img src="../../assets/pageright.svg" alt="" />
                  </span>
                </template>
              </b-pagination>
            </div>
          </div>
          <div
            v-else
            class="d-flex flex-column align-items-center justify-content-center"
            style="height: 90%"
          >
            <div>
              <img src="../../assets/img/jddetails/noresume.svg" alt="" />
            </div>
            <div>Resume not uploaded</div>
          </div>
        </div>
      </div>
      <b-modal
        id="acceptmodal"
        centered
        hide-footer
        hide-header
        no-close-on-backdrop
      >
        <b-overlay :show="showLoader" rounded="sm">
          <div
            class="
              modalheading
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <span>Accept Candidate</span>
          </div>
          <div v-if="!showLoader" @click="closeAcceptModal" class="xMarkCancel">
            <img src="../../assets/xmark.svg" alt="" />
          </div>

          <hr />
          <div class="remarks-ops-heading">
            Do you want to select the application of candidate "<b
              >{{ profileInfo.firstName }} {{ profileInfo.middleName }}
              {{ profileInfo.lastName }}</b
            >" for the JD ”<b>{{ this.$route.query.jobTitle }}</b
            >”?
          </div>
          <div class="topDiv mt-3">
            <label class="fieldsetStyle">Remarks</label>
            <b-form-textarea
              v-model="selectionRemark"
              class="remarksinput"
              rows="3"
              max-rows="4"
            >
            </b-form-textarea>
          </div>

          <div class="d-flex align-items-center justify-content-end mt-4">
            <div
              @click="closeAcceptModal"
              style="border: none"
              class="cancelbtn pointer"
            >
              Cancel
            </div>
            <div>
              <b-button @click="onAcceptandReject()" class="addbtn pl-3 pr-3">
                <span>Accept</span>
              </b-button>
            </div>
          </div>
        </b-overlay>
      </b-modal>
      <b-modal
        id="rejectmodal"
        centered
        hide-footer
        hide-header
        no-close-on-backdrop
        @hidden="closeRejectModal"
      >
        <b-overlay :show="showLoader" rounded="sm">
          <div
            class="
              modalheading
              d-flex
              align-items-center
              justify-content-between
            "
          >
            <span>Reject Candidate</span>
          </div>
          <div
            style="top: -24px; right: -24px"
            @click="closeRejectModal"
            class="xMarkCancel"
          >
            <img src="../../assets/xmark.svg" alt="" />
          </div>
          <hr />
          <div class="remarks-ops-heading">
            Are you sure you want to reject the application of candidate "<b
              >{{ profileInfo.firstName }} {{ profileInfo.middleName }}
              {{ profileInfo.lastName }}</b
            >" for the JD ”<b>{{ this.$route.query.jobTitle }}</b
            >”?
          </div>
          <div class="topDiv mt-3">
            <label class="fieldsetStyle"
              >Remarks &nbsp;<span class="asterik">*</span></label
            >
            <b-form-textarea
              placeholder="Enter Remarks"
              class="remarksinput"
              rows="3"
              max-rows="4"
              v-model.trim="$v.selectionRemark.$model"
              :class="{ error: $v.selectionRemark.$error }"
            >
            </b-form-textarea>
            <div
              class="validationicon"
              v-if="$v.selectionRemark.$dirty && !$v.selectionRemark.required"
              v-b-popover.hover.top.v-danger="{ content: 'Required' }"
            >
              <img src="../../assets/deletepopupicon.svg" alt="" />
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-end mt-4">
            <div
              @click="closeRejectModal"
              style="border: none"
              class="cancelbtn pointer"
            >
              Cancel
            </div>
            <b-button @click="onAcceptandReject()" class="addbtn pl-3 pr-3">
              <span>Reject</span>
            </b-button>
          </div>
        </b-overlay>
      </b-modal>
      <b-modal
        id="remarksModal"
        centered
        hide-footer
        hide-header
        no-close-on-backdrop
        @hidden="$bvModal.hide('remarksModal')"
      >
        <div @click="$bvModal.hide('remarksModal')" class="xMarkCancel">
          <img src="../../assets/xmark.svg" alt="" />
        </div>

        <div v-for="(remarkdata, index) in statusInfo.remarks" :key="index">
          <div class="remarks-ops-status">
            Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
            <span v-if="remarkdata.status == 1" class="remarks-green-text">
              Application Accepted by {{ remarkdata.userName }}
            </span>
            <span v-else class="remarks-red-text"
              >Application Rejected by {{ remarkdata.userName }}</span
            >
          </div>
          <div class="remarks-ops-status mt-2">
            Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;<span
              class="testconfig-card-subheadcontent"
            >
              {{ remarkdata.createdAt.slice(0, 10) | formatdate }}</span
            >
          </div>
          <div
            class="d-flex remarks-ops-status mt-3"
            v-if="remarkdata.remarks != undefined"
          >
            Remarks&nbsp;&nbsp;:&nbsp;
            <div class="testconfig-card-subheadcontent">
              {{ remarkdata.remarks }}
            </div>
          </div>
          <hr v-if="index != statusInfo.remarks.length - 1" />
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import {
  getCandidateProfileInfo,
  selectCandidatetoJD,
  candidateStatus,
} from "../../utils/apiFunctions";
import pdf from "vue-pdf";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import toast from "../../components/mixin/toast";
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { downloadFeedback } from "../../utils/download.js";
export default {
  name: "viewApplication",
  mixins: [toast],
  data() {
    return {
      profileInfo: [],
      numPages: 0,
      currentPage: 1,
      perPage: 1,
      statusInfo: {},
      LoaderStatus: false,
      showLoader: false,
      selectionKey: false,
      selectionRemark: "",
      showProjects: false,
      showEducation: false,
      showExperience: false,
      showSkills: false,
    };
  },
  components: {
    pdf,
    Spinner,
  },
  filters: {
    formatdate(data) {
      let datasplit = data.split("-");
      let datarev = datasplit.reverse();
      let datajoin = datarev.join("-");
      return datajoin;
    },
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  created() {
    this.LoaderStatus = true;
    this.getCandidateInfo();
    this.getcandidateStatus();
  },
  validations() {
    return {
      selectionRemark: {
        required,
      },
    };
  },
  methods: {
    downloadFeedback(url) {
      downloadFeedback(url);
    },
    async getCandidateInfo() {
      try {
        const res = await getCandidateProfileInfo(this.$route.query.email);
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.profileInfo = res.data.data;
        }
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! Status:${error.status}`);
      }
    },
    buildPayload() {
      return {
        jobID: this.$route.query.jobID,
        emailID: this.$route.query.email,
        select: this.selectionKey,
        remarks: this.selectionRemark,
      };
    },
    async selectCandidate() {
      try {
        if (!this.selectionKey) {
          this.$v.$touch();
          if (this.$v.$error) {
            this.errorModal("Please enter the remarks");
          } else if (!this.$v.$invalid) {
            let payload = this.buildPayload();
            await this.handleSelectionResult(payload);
          }
        } else {
          this.showLoader = true;
          let payloads = this.buildPayload();
          await this.handleSelectionResult(payloads);
        }
      } catch (error) {
        throw new Error(`Failed! Status:${error.status}`);
      }
    },

    async handleSelectionResult(payload) {
      const res = await selectCandidatetoJD(payload);
      if (res.status === 200) {
        this.showLoader = false;
        if (!this.selectionKey) {
          this.$v.$reset();
          this.$bvModal.hide("rejectmodal");
          this.$nextTick(() => {
            this.successModal(
              "Candidate's application has been rejected for the JD"
            );
          });
        } else {
          this.$bvModal.hide("acceptmodal");
          this.$nextTick(() => {
            this.successModal(
              "Candidate's application has been added to the JD"
            );
          });
        }
        this.goBack();
      }
    },
    async getcandidateStatus() {
      try {
        let payload = {
          jobID: this.$route.query.jobID,
          emailID: this.$route.query.email,
        };
        const res = await candidateStatus(payload);
        if (res.status == 200) {
          this.statusInfo = res.data.data;
          this.LoaderStatus = false;
        }
      } catch (error) {
        throw new Error(`Failed! Status:${error.status}`);
      }
    },
    // method is used education, experience, projects and skills to display the dates in shorter format
    getITCDateTime(utcDateTime) {
      const utcDate = new Date(utcDateTime);
      const monthName = utcDate.toLocaleString("default", { month: "short" });
      const year = utcDate.getFullYear();
      const formattedDate = `${monthName} ${year}`;
      return formattedDate;
    },

    getITCDateMonth(utcDateTime) {
      const utcDate = new Date(utcDateTime);
      const monthName = utcDate.toLocaleString("default", { month: "short" });
      const formattedDate = `${monthName}`;
      return formattedDate;
    },

    getITCDateYear(utcDateTime) {
      const utcDate = new Date(utcDateTime);
      const year = utcDate.getFullYear();
      const formattedDate = `${year}`;
      return formattedDate;
    },
    // CLOSE ACCEPT MODAL
    closeAcceptModal() {
      this.$bvModal.hide("acceptmodal");
      this.selectionRemark = "";
    },
    closeRejectModal() {
      this.$v.$reset();
      this.$bvModal.hide("rejectmodal");
      this.selectionRemark = "";
    },
    onAcceptandReject() {
      this.selectCandidate();
    },
    // HELPER FUNCTIONS FOR NAVIGATIONS
    goBack() {
      this.$router.push({
        name: "ApplicationTable",
        query: {
          cardName: this.$route.query.cardName,
          jobTitle: this.$route.query.jobTitle,
          jobID: this.$route.query.jobID,
          customerID: this.$route.query.customerID,
          status: this.$route.query.status,
          itype: this.$route.query.itype,
          isort: this.$route.query.isort,
          type: this.$route.query.type,
          sort: this.$route.query.sort,
          appstatus: this.$route.query.appstatus,
        },
      });
    },
  },
};
</script>

<style scoped>
.rcs-template-card {
  background: white;
  background: #fbfbfb;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 0px 30px rgba(86, 86, 86, 0.2);
  border-radius: 5px;
  margin-top: 10px;
}

.rcs-remarks-right {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}

.ap-right-container {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  height: calc(100vh - 150px);
  padding: 15px;
  width: 40%;
  overflow: auto;
  margin-top: 10px;
}

.rcs-left-container {
  background: #ffffff;
  border-radius: 8px;
  width: 60%;
  overflow: auto;
  padding: 10px;
  height: calc(100vh - 185px);
}

.cancelbtntext {
  font-weight: 600;
  font-size: 13px;
  color: #72738e;
  border: 1px solid #72738e;
  padding: 5px 25px;
  border-radius: 3px;
}

.profile-img {
  border-radius: 50%;
  overflow: hidden;
  height: 70px;
  width: 70px;
}

.vcs-email {
  color: #333;
  font-size: 12px;
  text-decoration-line: underline;
}

.viewcandidate-educationinfo {
  background: #ffffff;
  box-shadow: 0px 4px 20px rgb(196 196 196 / 50%);
  border-radius: 8px;
  padding: 15px;
}

.cand-container-main-heading {
  font-weight: 600;
  font-size: 14px;
  text-transform: capitalize;
  color: #464667;
}

.cand-container-subheading {
  font-weight: 600;
  font-size: 14px;
  color: #696969;
}

.cand-dash-asses-desc {
  font-weight: 400;
  font-size: 13px;
  color: #737373;
}

.datesofcontent {
  font-weight: 400;
  font-size: 14px;
  color: #72738e;
}

.projname-box {
  background: #f6f6fc;
  border-radius: 5px;
  font-weight: 500;
  font-size: 14px;

  text-transform: capitalize;
  padding: 3px;
  color: #696969;
}

.proj-submainheads {
  font-weight: 400;
  font-size: 13px;
  text-transform: capitalize;

  color: #464667;
}

.vcs-skillBox {
  border-radius: 4px;
  background: #e8e5e5;
  color: #72738e;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 6px;
  margin: 0px 10px 5px 0px;
}
.vcs-left-cont-btn {
  position: absolute;
  bottom: 10px;
}
.remarksinput {
  background: #fdfdfd;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  font-weight: 400;
  font-size: 12px;
  cursor: pointer;
}
</style>
